import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold mb-6" }
const _hoisted_2 = { class: "text-black font-light text-xs leading-relaxed whitespace-pre-line" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = ["src", "alt", "onClick"]
const _hoisted_5 = { class: "flex gap-1.5 h-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "absolute left-0 right-0 mt-10 transition-all duration-300" }
const _hoisted_8 = { class: "bg-brand-main rounded-xl p-2 text-white text-center relative" }
const _hoisted_9 = { class: "text-xs leading-relaxed" }

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailCutContent',
  props: {
    cut: { default: "ex" },
    mobileMode: { type: Boolean, default: false },
    stoneType: { default: 'earth' }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const host = process.env.VUE_APP_HOST;

const allCuts = [
  {
    key: "gd",
    label: "Good",
    img: "/img/diamonds/details/cut_gd.webp",
  },
  {
    key: "vg",
    label: "Very Good",
    img: "/img/diamonds/details/cut_vg.webp",
  },
  {
    key: "ex",
    label: "Excellent",
    img: "/img/diamonds/details/cut_ex.webp",
  },
  {
    key: "id",
    label: "Ideal",
    img: "/img/diamonds/details/cut_id.webp",
  },
];

const cuts = computed(() => {
  if (props.stoneType === "earth") {
    return allCuts.filter((c) => c.key !== "id");
  }
  return allCuts;
});

const getNormalizedCut = (c: string) => {
  if (!c) return "ex";
  c = c.toLowerCase();
  if (c === "id" || c === "ideal") return "id";
  if (c === "ex" || c === "excellent") return "ex";
  if (c === "vg" || c === "very good") return "vg";
  if (c === "gd" || c === "good") return "gd";
  return c;
};

const getInitialIndex = () => {
  const cutValue = Array.isArray(props.cut) ? props.cut[0] : props.cut;
  if (!cutValue) return cuts.value.findIndex((c) => c.key === "ex") ?? 0;
  const normalized = getNormalizedCut(cutValue);
  const index = cuts.value.findIndex((c) => c.key === normalized);
  return index !== -1 ? index : (cuts.value.findIndex((c) => c.key === "ex") ?? 0);
};

const selectedIndex = ref(getInitialIndex());

const isMobile = ref(window.innerWidth < 769);
const updateMobile = () => {
  isMobile.value = window.innerWidth < 769;
};

const isMobileMode = computed(() => props.mobileMode || isMobile.value);

watch(() => [props.cut, props.stoneType], () => {
  selectedIndex.value = getInitialIndex();
});

const sliderRef = ref<HTMLElement | null>(null);
const isDragging = ref(false);

const updateIndexFromEvent = (e: MouseEvent | TouchEvent) => {
  if (!sliderRef.value) return;
  const rect = sliderRef.value.getBoundingClientRect();
  const clientX =
    "touches" in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
  const offsetX = clientX - rect.left;
  let percentage = offsetX / rect.width;
  percentage = Math.max(0, Math.min(0.99, percentage));
  selectedIndex.value = Math.floor(percentage * cuts.value.length);
};

const startDragging = (e: MouseEvent | TouchEvent) => {
  isDragging.value = true;
  updateIndexFromEvent(e);
};

const handleMove = (e: MouseEvent | TouchEvent) => {
  if (isDragging.value) {
    updateIndexFromEvent(e);
  }
};

const stopDragging = () => {
  isDragging.value = false;
};

onMounted(() => {
  window.addEventListener("mousemove", handleMove);
  window.addEventListener("mouseup", stopDragging);
  window.addEventListener("touchmove", handleMove, { passive: false });
  window.addEventListener("touchend", stopDragging);
  window.addEventListener("resize", updateMobile);
});

onUnmounted(() => {
  window.removeEventListener("mousemove", handleMove);
  window.removeEventListener("mouseup", stopDragging);
  window.removeEventListener("touchmove", handleMove);
  window.removeEventListener("touchend", stopDragging);
  window.removeEventListener("resize", updateMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex flex-col items-center ', isMobileMode.value ? '' : 'md:gap-12 md:flex-row'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['w-full text-left', isMobileMode.value ? '' : 'md:w-1/3'])
    }, [
      _renderSlot(_ctx.$slots, "title", {
        selectedLabel: cuts.value[selectedIndex.value]?.label
      }, () => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("components.diamonds.details.cut.title")) + ": " + _toDisplayString(cuts.value[selectedIndex.value]?.label), 1)
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("components.diamonds.details.cut.content_text")), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['w-full', isMobileMode.value ? '' : 'md:w-2/3'])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['flex justify-center items-end mb-6', isMobileMode.value ? '' : 'md:justify-between'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cuts.value, (c, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c.key,
              class: _normalizeClass(["justify-center px-2 flex", [
              selectedIndex.value === index ? 'flex' : (isMobileMode.value ? 'hidden' : 'hidden md:flex'),
              isMobileMode.value ? '' : 'md:flex-1',
            ]])
            }, [
              _createElementVNode("img", {
                src: _unref(host) + c.img,
                alt: c.label,
                class: _normalizeClass(["transition-opacity duration-300 cursor-pointer", [
                isMobileMode.value ? 'h-52 w-80 object-cover max-w-[420px]' : 'max-w-[420px] md:max-w-[140px]',
                { 'md:opacity-90': !isMobileMode.value && selectedIndex.value !== index }
              ]]),
                onClick: ($event: any) => (selectedIndex.value = index)
              }, null, 10, _hoisted_4)
            ], 2))
          }), 128))
        ], 2),
        _createElementVNode("div", {
          class: "relative pb-32 cursor-pointer",
          ref_key: "sliderRef",
          ref: sliderRef,
          onMousedown: startDragging,
          onTouchstart: _withModifiers(startDragging, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cuts.value, (c, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'bar-' + c.key,
                class: "flex-1 cursor-pointer relative group",
                onClick: ($event: any) => (selectedIndex.value = index)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-full w-full rounded-full transition-colors duration-300", 
                  selectedIndex.value === index ? 'bg-brand-main' : 'bg-brand-main/30'
                ])
                }, null, 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute top-2 left-1/2 -translate-x-1/2 text-sm transition-colors duration-300 whitespace-nowrap", 
                  selectedIndex.value === index
                    ? 'text-brand-main font-medium'
                    : 'text-gray-400'
                ])
                }, _toDisplayString(c.label), 3)
              ], 8, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "absolute -top-2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-brand-main transition-all duration-300",
                style: _normalizeStyle({ left: `calc(${selectedIndex.value * (100 / cuts.value.length) + (100 / cuts.value.length) / 2}% - 10px)` })
              }, null, 4),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("components.diamonds.details.cut.descriptions." + cuts.value[selectedIndex.value]?.key)), 1)
            ])
          ])
        ], 544)
      ])
    ], 2)
  ], 2))
}
}

})